
// This is the general purpose app-wide store.
import { defineStore } from 'pinia'
// import bus from "/src/utils/event_bus"
import { useSessionStore } from "./session"
import { useRefurbishmentStore } from './refurb';
import { useShipmentsStore } from './shipments';


export const useAppStore = defineStore('app', {
  state: () => ({
    active_loaders: [],  // Loading calls that are running
    bootup: true, // Only at startup is true
    route_name: "",
    connection_lost: false,
  }),
  getters: {
    loading: state => state.active_loaders.length != 0,
    loader_is_active: state => (loaders) => {
      if (Array.isArray(loaders)) {
        return loaders.some(loader => state.active_loaders.includes(loader));
      } else {
        return state.active_loaders.includes(loaders);
      }
    },
  },
  actions: {
    resetStore() {
      this.active_loaders = []
      this.bootup = false
      this.route_name = ""
      this.connection_lost = false
    },
    pushLoading(load) { this.active_loaders.push(load) },
    popLoading(load) { this.active_loaders = this.active_loaders.filter(l => l != load) },
    popLoadingIncludes(load) { this.active_loaders = this.active_loaders.filter(l => !l.includes(load)) },
    ready() { this.loading = false },
    endBootup() { this.bootup = false },
    setRouteName(name) { this.route_name = name },
    setConnectionLost(status) { this.connection_lost = status },



    async initialLoad(isExternalUser = false) {
      console.log("INITIAL LOAD")
      const refurb_store = useRefurbishmentStore()
      const shipments_store = useShipmentsStore()
      const session_store = useSessionStore()
      
      // Para usuarios externos: NO cargar datos de negocio aquí (cada vista carga lo suyo),
      // pero sí la lista de compañías para alimentar el selector global (issue #145).
      if (isExternalUser) {
        console.log('[INITIAL_LOAD] External user - loading companies for selector only.');
        // Inicializa la selección a la compañía propia de inmediato (solo necesita el
        // user object, ya disponible) para que el selector no muestre estado vacío.
        session_store.initActiveCompanies();
        return session_store.loadCompanies()
          .catch(e => console.warn('[INITIAL_LOAD] loadCompanies failed:', e?.message));
      }
      
      // Para usuarios internos: cargar todos los datos
      console.log('[INITIAL_LOAD] Internal user - loading all data');
      return Promise.all([
        refurb_store.loadRSOs(),
        session_store.loadCompanies(),
        session_store.loadUsers(),
        session_store.loadHoldings(),
        refurb_store.loadWorkOrders(),
        shipments_store.loadShipments(),
        shipments_store.loadLocations(),
        shipments_store.loadContainers()
      ]);
    },
    async refreshBaseUserData() {
      this.pushLoading("base_user_data")
      const session_store = useSessionStore()
      return Promise.all([
        session_store.getUserObject(),
      ]).then(() => {
        if (this.bootup) {
          this.endBootup()
        }
      }).finally(() => this.popLoading("base_user_data"))
    },
  }
})
